"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorageStrategy = void 0;
var SessionStorageStrategy = /** @class */ (function () {
    function SessionStorageStrategy() {
    }
    SessionStorageStrategy.prototype.getItem = function (key) {
        var value = sessionStorage.getItem(key);
        if (value !== null) {
            try {
                return Promise.resolve(JSON.parse(value));
            }
            catch (e) {
                return Promise.resolve(value);
            }
        }
        return Promise.reject(key);
    };
    SessionStorageStrategy.prototype.setItem = function (key, object) {
        if (typeof object === 'string') {
            sessionStorage.setItem(key, object);
        }
        else {
            try {
                sessionStorage.setItem(key, JSON.stringify(object));
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
        return Promise.resolve(object);
    };
    SessionStorageStrategy.prototype.removeItem = function (key) {
        var item = sessionStorage.getItem(key);
        if (item) {
            sessionStorage.removeItem(key);
            return Promise.resolve('');
        }
        return Promise.reject(key);
    };
    SessionStorageStrategy.prototype.clear = function () {
        sessionStorage.clear();
        return Promise.resolve('');
    };
    SessionStorageStrategy.ID = 'sessionStorage';
    return SessionStorageStrategy;
}());
exports.SessionStorageStrategy = SessionStorageStrategy;
